import { useCallback, useContext } from "react";
import { StateContext } from "../context/globalContext/context";
import { iGlobalContext } from "../context/globalContext/interface";

export function useResetState() {
  const state = useContext(StateContext);
  const {
    setFlightData,
    setHotelData,
    setShowMore,
    setAirPorts,
    setBookingDetails,
    setHotelPagination,
    selectedChatData,
    setHideDetails,
    setSearch,
    setIsFetchingFlights,
    setIsFetchingHotels,
    setHotelInputFieldMissingError,
    setFlightTTL,
    setOnBoardForm,
    setPromoCode,
    setPayDetails,
    setPromoReviewCartData,
    setPromoDetails,
    setActivityData,
    setActivitySearchParams,
    setIsFetchingActivities,
    setIsActivityFormDirty,
    setShowActivityCollapsedHeader,
    setIsActivityReviewPage,
    setShowCancelActivitiesModal,
    setManageActivitiesArr,
    setActivityCancelReasonCode,
  }: iGlobalContext = state;
  const isItineraryAvailable = selectedChatData?.id === "" ? false : true;
  const resetState = useCallback(() => {
    setFlightData(null);
    setHotelData(null);
    // setPromoCode([]);
    setPromoDetails(null);
    // setFlightTTL(null);
    setHideDetails(false);
    setIsFetchingFlights(false);
    setIsFetchingHotels(false);
    setHotelInputFieldMissingError(false);
    setSearch({
      flight: true,
      hotel: true,
      flightAvailability: false,
      flightDetails: false,
      baggageAndFareRules: false,
    });
    // setSelectedFlightOptions({ flights: true, hotels: true });
    setShowMore({ visibleList: { flight: 4, hotel: 4, package: 2 } });
    setAirPorts([]);
    setHotelPagination([]);
    setBookingDetails((prevData) => ({
      ...prevData,
      addedFlightTimeStamp: null,
      adultsCount: 1,
      childrenCount: 0,
      seniorsCount: 0,
      infantCount: 0,
      infantLapCount: 0,
      adultsHotelCount: 2,
      childrenHotelCount: 0,
      seniorsHotelCount: 0,
      infantHotelCount: 0,
      roomInfo: [{ roomNo: 1, adults: 2, child: 0, childAges: "" }],
      childrenAges: undefined,
      airportFrom: "",
      airportTo: "",
      travelFromDate: "",
      travelToDate: "",
      routeType: "2",
      flightClass: "E",
      cities: ["Barcelona"],
      checkIn: "",
      checkOut: "",
      numberOfRoomCount: 1,
      tripType: 2,
      update: false,
      hideFlights: false,
      hideHotels: false,
      isHotelSearchApiCalled: false,
      isThisMultiCityTrip: false,
      bookingParams: false,
      isFormUpdated: {
        arrivalForm: false,
        departureForm: false,
      },
      isDataModified: {
        flight: false,
        hotel: false,
      },
      selectedFlightId: "",
      airlines: null,
      hotelChains: null,
      flightDayPart: "",
      numberOfStops: "",
      flightRefundable: "",
      noMoreFlights: false,
      expandedAccordions: [],
      cityInfo: {
        departure: "",
        arrival: "",
      },
      applyFilters: {
        flight: false,
        hotel: false,
      },
      selectedLocation: {
        city: "",
        state: "",
        country: "",
        latitude: 0,
        longitude: 0,
      },
      selectedArrivalLocation: {
        city: "",
        state: "",
        country: "",
        latitude: 0,
        longitude: 0,
      },
      flightPreferences: {
        connections: null,
        departureTime: [],
        refundable: null,
        airlines: [],
        departureTimeInSlider: [],
      },
      hotelPreferences: {
        refundable: null,
        hotelChains: [],
        accommodationTypes: isItineraryAvailable ? [] : ["hotel"],
        userRatings: null,
        starRatings: [],
      },
      flightHistory: [
        {
          city_name: "",
          flights: [],
          number_of_days: 0,
        },
      ],
      hotels: [
        {
          checkIn: "",
          checkOut: "",
          country: "",
          city: "",
          latitude: "",
          longitude: "",
        },
      ],
      airPort: [
        {
          flightDepartureTime: "",
          returnTime: "",
          isSelected: false,
          departureCityAddress: "",
          arrivalCityAddress: "",
          arrivalAddress: "",
          departureAddress: "",
          arrivalGoogleAddress: "",
          departureGoogleAddress: "",
          newArrivalAddress: "",
          newDepartureAddress: "",
          arrival: "",
          departure: "",
          fromCity: "",
          destinationCity: "",
          departureDate: "",
          returnDate: "",
          departureAirportFullName: "",
          arrivalAirportFullName: "",
          arrivalCityLatitude: "",
          arrivalCityLongitude: "",
          departureCityLatitude: "",
          departureCityLongitude: "",
          noOfDays: 0,
          newArrivalCitySearch: false,
          newDepartureCitySearch: false,
          arrivalCityDetails: "",
          departureCityDetails: "",
          arrivalSelectedLocation: {
            city: "",
            state: "",
            country: "",
            latitude: 0,
            longitude: 0,
          },
          departureSelectedLocation: {
            city: "",
            state: "",
            country: "",
            latitude: 0,
            longitude: 0,
          },
        },
      ],
      travelJourneyData: [
        {
          departureCityAddress: "",
          arrivalCityAddress: "",
          departureDate: "",
          returnDate: "",
          days: [],
          flightCheckIn: "",
          flightCheckOut: "",
          totalDays: 0,
          flightTime: "",
        },
      ],
      visibleList: {
        flight: 12,
        hotel: 12,
        package: 0,
      },
      filters: {
        starRating: [],
      },
    }));
    setPayDetails((prevData) => ({
      ...prevData,
      paymentIntentId: "",
      secretKey: "",
      totalAmount: 0,
      discountAmount: 0,
      totalAmountAfterDiscount: 0,
      paymentId: "0",
      promo: {
        code: "",
        description: "",
        id: "",
        status: "",
        message: "",
        errorCode: 400,
      },
    }));
    setPromoReviewCartData(null);
    setOnBoardForm({
      home: { city: "", state: "", country: "" },
      travelWith: "",
      lookingFor: [],
      budget: "Economy",
      selectedBudget: 1,
      signUpOffer: null,
      isOfferAvailable: false,
    });
    setActivityData(null);
    setActivitySearchParams(null);
    setIsFetchingActivities(false);
    setIsActivityFormDirty(false);
    setShowActivityCollapsedHeader(false);
    setIsActivityReviewPage(false);
    setShowCancelActivitiesModal(false);
    setManageActivitiesArr([]);
    setActivityCancelReasonCode("");
    // SMA-1013: a fresh booking session should never inherit the previous
    // session's Stripe retry counter or its persisted error message — belt
    // and suspenders alongside the reset in /paymentsuccess and the
    // "See other options" handler.
    try {
      sessionStorage.removeItem("_zenvoya_booking_retry_count");
      sessionStorage.removeItem("_zenvoya_stripe_error_message");
      // The activity flow keeps a SECOND store beyond `activityData` /
      // `activitySearchParams` (both cleared above): its own step snapshot,
      // which also holds `citiesSearchParams` — the destination and dates.
      // Without removing it here the Activities form restored the previous
      // search's dates after a reset + refresh, while Stays (whose only store
      // is `bookingDetails`) came back empty. Same parity for the review step.
      sessionStorage.removeItem("activity_booking_flow_state");
      sessionStorage.removeItem("activity_review_state");
    } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    setFlightData,
    setHotelData,
    setPromoCode,
    setFlightTTL,
    setHideDetails,
    setIsFetchingFlights,
    setIsFetchingHotels,
    setHotelInputFieldMissingError,
    setSearch,
    setShowMore,
    setAirPorts,
    setHotelPagination,
    setBookingDetails,
    setOnBoardForm,
    isItineraryAvailable,
    setActivityData,
    setActivitySearchParams,
    setIsFetchingActivities,
    setIsActivityFormDirty,
    setShowActivityCollapsedHeader,
    setIsActivityReviewPage,
    setShowCancelActivitiesModal,
    setManageActivitiesArr,
    setActivityCancelReasonCode,
  ]);

  return resetState;
}
